import { Box, ListItem, Text } from '@domain-group/suit-theme'

import usePublicationEdition from '@hooks/usePublicationEdition'

import type { PublicationEditionModel } from '@models/types'

type RenderDateColorParams = {
  bookingDeadlinePassed: boolean,
  selected: boolean,
}

const renderDateColor = (params: RenderDateColorParams) => {
  const { bookingDeadlinePassed, selected } = params

  if (selected) return 'white'
  if (bookingDeadlinePassed) return 'faintGrey'

  return 'bodyFontColor'
}

interface PublicationEditionProps {
  callbacks: {
    selectPublicationEdition: VoidFunction,
  },
  publicationEdition: PublicationEditionModel,
  selected?: boolean,
}

const PublicationEdition = (props: PublicationEditionProps) => {
  const {
    callbacks: {
      selectPublicationEdition,
    },
    publicationEdition,
    selected = false,
  } = props

  const publicationEditionPayload = usePublicationEdition(publicationEdition)
  const {
    bookingDeadlineObj,
    bookingDeadlinePassed,
    publicationEdition: {
      title,
    },
    publicationDateObj,
  } = publicationEditionPayload

  const dateTileTextColour = renderDateColor({ bookingDeadlinePassed, selected })

  return (
    <ListItem
      borderColor={selected ? 'blue' : 'lineColor'}
      boxProps={{
        border: '1px solid',
        borderRadius: 5,
        paddingY: 'medium',
        marginBottom: 'medium',
      }}
      forceBottomBorder
      onClick={() => selectPublicationEdition()}
    >
      <Box
        borderRight="1px solid"
        borderColor="lineColor"
        flexShrink={0}
        justifyContent="center"
        width="auto"
      >
        <Box
          alignItems="center"
          backgroundColor={selected ? 'blue' : 'whiteGrey'}
          borderRadius={5}
          flexDirection="column"
          justifyContent="center"
          padding="medium"
          marginX="medium"
          width="40px"
        >
          <Text color={dateTileTextColour} fontWeight="bold" fontSize="small">
            {publicationDateObj.toFormat('d')}
          </Text>
          <Text color={dateTileTextColour} fontSize="xxsmall" style={{ letterSpacing: '1px' }}>
            {publicationDateObj.toFormat('MMM')}
          </Text>
        </Box>
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="medium">
        <Text color={bookingDeadlinePassed ? 'faintGrey' : 'bodyFontColor'} fontSize="small">
          {bookingDeadlinePassed ? `${title} (Booking Passed)` : title}
        </Text>
        <Text color={bookingDeadlinePassed ? 'faintGrey' : 'bodyFontLightColor'} fontSize="xsmall" marginTop="small">
          {`Booking: ${bookingDeadlineObj.toFormat("ccc d MMM yyyy 'at' h:mma")}`}
        </Text>
      </Box>
    </ListItem>
  )
}

export default PublicationEdition
